import React from "react"
import { useNavigate } from "react-router-dom"
import { ArrowLeft, ChevronLeft } from "react-feather"

import { useMedia } from "../../../../hooks/useMedia"

import "./index.scss"

function SectionHeader({ handleGoBack, withBorder = false, children }) {
  const navigate = useNavigate()
  const isMobile = useMedia("(max-width: 960px)")

  function handleBackPage() {
    if (handleGoBack) {
      handleGoBack()
    } else {
      navigate(-1)
    }
  }

  function returnClassName() {
    let className = 'section-header'

    if(withBorder) className += ' section-header--with-border'

    return className
  }

  return (
    <div className={returnClassName()}>
      <div className="section-header__container">
        {handleGoBack && !isMobile && (
          <ArrowLeft size={24} onClick={handleBackPage} />
        )}
        {handleGoBack && isMobile && (
          <ChevronLeft size={24} onClick={handleBackPage} />
        )}
        {children}
      </div>
    </div>
  )
}

export default SectionHeader
